import { partial } from 'lodash';
import { BoilerAdapter, HeatingCircuit } from 'z3k-config';
import { isHeatingCircuitHidden, isNeedBoiler } from './utils';
import { fixObjectName } from 'z3k-settings/utils/fix-object-name';
import { HeatingCircuitInBoilerCascade } from 'z3k-parser/lib/heating-circuit';
export function getZ3KBoilerHeatingCircuitsConfig(z3k_config, show_hidden_elements) {
    const heating_circuits = HeatingCircuit.get.where(z3k_config, partial(isNeedBoiler, true));
    const shared_heating_circuits = heating_circuits.map((z3k_circuit) => {
        const { id, name, control_devices } = z3k_circuit;
        const is_hidden = isHeatingCircuitHidden(z3k_circuit) && !show_hidden_elements;
        if (is_hidden) {
            return null;
        }
        if (!HeatingCircuit.isEnabled(z3k_circuit)) {
            return null;
        }
        const boiler_cascade = HeatingCircuitInBoilerCascade(z3k_circuit, z3k_config);
        const boiler_adapter = BoilerAdapter.get.one(z3k_config, ({ id }) => {
            if (control_devices) {
                return control_devices.includes(id);
            }
            return false;
        });
        const boiler_model = boiler_adapter?.boiler_model;
        const boiler_type = boiler_adapter?.type;
        const not_available_ot_flags = boiler_adapter != null
            ? BoilerAdapter.notAvailableOTParameters(boiler_adapter)
            : new Set();
        return {
            id,
            name: fixObjectName(name),
            boiler_cascade,
            boiler_model,
            control_devices,
            boiler_type,
            not_available_ot_flags,
            z3k_circuit,
        };
    });
    return shared_heating_circuits;
}
